import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Loading from '../../pages/Loading/Loading';


const CategoriesItem = () => {

    const navigate = useNavigate();

    const { data, isLoading } = useQuery("categoryMenu", () => fetch(`${process.env.REACT_APP_SECRET_API}/category`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()
    )
    )

    if (isLoading) {
        return <Loading></Loading>
    }

    const category = data?.data

    const redirectToCategoriesProducts = (categoryId) => {
        navigate(`/categories-products/${categoryId}`);
   
    };

    return (
        <>
            {category.slice(0, 10).map(item => (
                <button key={item?.id} onClick={() => redirectToCategoriesProducts(item?.id)} className="w-full py-3 flex items-left hover:bg-gray-100 transition">
                    <span className="ml-6 text-gray-600 text-sm truncate w-28 text-left">{item?.name}</span>
                </button>

            ))}

            <button onClick={() => navigate("/all-category")} className="py-3 overflow-hidden w-full bg-primary flex items-left hover:bg-secondary transition">
                <span className="ml-6 font-semibold text-sm text-white">See More</span>
            </button>
        </>
    );
};

export default CategoriesItem;